// BULK Trader Revamp
/** Absolute path prefix for the bulk trader revamp UI (`BULK_TRADER` + `bulk_trader_revamp` flag). */
export const BULK_TRADER_REVAMP_BASE_PATH = '/bulkTraderRevamp';
